import { render } from "./UserAuth.vue?vue&type=template&id=32d3a62a&scoped=true"
import script from "./UserAuth.vue?vue&type=script&lang=js"
export * from "./UserAuth.vue?vue&type=script&lang=js"

import "./UserAuth.vue?vue&type=style&index=0&id=32d3a62a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-32d3a62a"

export default script